<app-header></app-header>

<div class="wrapper">

  <app-estimate-box [isLoader]="isLoader"
    [submitBtnLabel]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'"
    (submitBtnClick)="saveBasementDetails(historyState.isPaymentDone ? 'submit' : 'skip')"
    (forwardClick)="saveBasementDetails(null)" (backClick)="back()"></app-estimate-box>

  <div class="section_wrapper" style="margin-top: 20px;">
    <!-- stepper component -->
    <div class="dashBoard basement_details_wrap">
      <app-stepper currentIndex="1.3" class="stepper"></app-stepper>
      <div class="basement_details w_100">
        <div class="basement_details_form">
          <h3 class="font_40_a32">Basement</h3>
          <div class=" form_section">
            <mat-form-field class="w_100 genericTextFiled_h60" appearance="fill">
              <mat-label>Basement Type</mat-label>
              <mat-select [(ngModel)]="BasementType" name="food">
                <mat-option *ngFor="let basement of basementType" [value]="basement.value">
                  {{basement.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w_100 genericTextFiled_h60" appearance="fill">
              <mat-label>Basement Exit</mat-label>
              <mat-select [(ngModel)]="BasementEntry" name="BasementEntry">
                <mat-option *ngFor="let basement of basementEntry" [value]="basement.value">
                  {{basement.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w_100 genericTextFiled_h60">
              <mat-label>Basement Total Area</mat-label>
              <input matInput type="number" min="0" placeholder="" name="" [(ngModel)]=BelowGradeTotalArea>
              <span matSuffix class="suffix_text">SqFt</span>

            </mat-form-field>
            <mat-error *ngIf="basementAreaFlag==true">please enter basement total area to continue</mat-error>
            <mat-form-field class="w_100 genericTextFiled_h60">
              <mat-label>Basement Finished Area</mat-label>
              <input matInput type="number" min="0" placeholder="" name="" [(ngModel)]=BelowGradeFinishedArea>
              <span matSuffix class="suffix_text">SqFt</span>
            </mat-form-field>
            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Basement Rooms</mat-label>
              <mat-chip-grid #chipGrid aria-label="Other Basement selection">
                <mat-chip-row *ngFor="let room of Basement" (removed)="remove(room)">
                  {{room}}
                  <button matChipRemove [attr.aria-label]="'remove ' + room">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #roomInput [formControl]="roomCtrl" [matChipInputFor]="chipGrid"
                [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)" />
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let room of filteredRooms | async" [value]="room">
                  {{room}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <!-- <div class="submit_buttons">
            <p class="save_text" *ngIf="historyState.basementDetails">
              <span class="check_icon"><img src="../../../assets/icons/check_green.svg" alt="done"></span>
              Saved
            </p>

            <div class="buttons">

              <button class="back_button" *ngIf="!isLoader" (click)="saveBasementDetails()">Next</button>

              <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>

              <app-green-button-v2 (click)="saveBasementDetails('skip')" label="Choose Plan"
                *ngIf="!isLoader && !historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

              <app-green-button-v2 (click)="saveBasementDetails('submit')" label="Submit Listing"
                *ngIf="!isLoader && historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

            </div>
          </div> -->

          <div class="mobile_submitButtons">
            <button class="arrowBtn leftArrow" (click)="back()">
              <img src="../../../assets/icons/arrow_left_grey.svg" alt="arrow_left">
            </button>
            <app-green-button-v2 class="SumbitBtnRes"
              (click)="saveBasementDetails(historyState.isPaymentDone ? 'submit' : 'skip')"
              [label]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'" [buttonType]="'submit'"
              [width]="'136px'" [height]="'50px'">
            </app-green-button-v2>
            <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
            <button (click)="saveBasementDetails(null)" class="arrowBtn rightArrow">
              <img src="../../../assets/icons/arrow_right_grey.svg" alt="arrow-right">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>